import React from "react";

import { format } from "date-fns";

//Material Icons
import { PushPin } from "@mui/icons-material";

//UI Material
import { Card, Chip, Stack } from "@mui/material";

//Helpers
import {
  typographyForCustomizedFontSize,
} from "../../Helpers/typography";

export default function FixedCollaborator({
  data = [],
  selectedDate,
  user,
  expectation = 10,
}) {
  // ==========> Component Functions<==========
  //Function to get the results for each user by day
  const getPersonalDailyResults = () => {
    let count = 0;

    for (let i of data) {
      if (
        i.assemblyBy === user.email &&
        format(new Date(i.assemblyAt), "yyyy-MM-dd") ===
          format(new Date(selectedDate), "yyyy-MM-dd")
      ) {
        count++;
      }

      if (
        i.testedBy === user.email &&
        format(new Date(i.testedAt), "yyyy-MM-dd") ===
          format(new Date(selectedDate), "yyyy-MM-dd")
      ) {
        count++;
      }
    }

    let percentage = (100 * count) / expectation;

    if (percentage < 85) {
      return typographyForCustomizedFontSize(
        `${Number(percentage).toFixed(1)}%`,
        "11.5px",
        "orange",
        "bold"
      );
    } else {
      return typographyForCustomizedFontSize(
        `${Number(percentage).toFixed(1)}%`,
        "11.5px",
        "rgb(28,187,49)",
        "bold"
      );
    }
  };

  // ==========> Component <==========
  return (
    <Card
      raised
      sx={{
        backgroundColor: "#007878",
        color: "white",
      }}
    >
      <Stack spacing={1} sx={{ padding: "10px" }}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1} textAlign="left">
            <PushPin />
            {typographyForCustomizedFontSize(user.user, "11.5px", null, "bold")}
          </Stack>

          {getPersonalDailyResults()}
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center" textAlign="left">
          <Chip
            sx={{ color: "white", width: "55px" }}
            variant="outlined"
            label={
              data.filter((p) => {
                return (
                  p.assemblyBy === user.email &&
                  format(new Date(p.assemblyAt), "yyyy-MM-dd") ===
                    format(new Date(selectedDate), "yyyy-MM-dd")
                );
              }).length
            }
          />
          {typographyForCustomizedFontSize("ensamblados", "11px", null, "bold")}
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center" textAlign="left">
          <Chip
            sx={{ color: "white", width: "55px" }}
            variant="outlined"
            label={
              data.filter((p) => {
                return (
                  p.testedBy === user.email &&
                  format(new Date(p.testedAt), "yyyy-MM-dd") ===
                    format(new Date(selectedDate), "yyyy-MM-dd")
                );
              }).length
            }
          />
          {typographyForCustomizedFontSize("probados", "11px", null, "bold")}
        </Stack>
      </Stack>
    </Card>
  );
}
